// extracted by mini-css-extract-plugin
export default {"btnContainer":"TelecomSites_btnContainer__5RNjj","header":"TelecomSites_header__0p4WE","actionsCell":"TelecomSites_actionsCell__nI3Ei"};